import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'brn-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input()
  color:
    | string
    | 'red'
    | 'green'
    | 'blue'
    | 'yellow'
    | 'brown'
    | 'violet'
    | 'default' = 'default';
  @Input()
  shadow = false;

  constructor() {}

  get colorScheme(): string {
    return 'scheme--' + this.color;
  }

  get shadowClass(): string {
    return this.shadow ? 'shadow' : '';
  }

  ngOnInit(): void {}
}
